module.exports = __webpack_public_path__ + "img/1970East-014_WEB-min.ecc49878.jpg";